var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M624,352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494,110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48 H48C21.5,0,0,21.5,0,48v320c0,26.5,21.5,48,48,48h16c0,53,43,96,96,96s96-43,96-96h128c0,53,43,96,96,96s96-43,96-96h48 c8.8,0,16-7.2,16-16v-32C640,359.2,632.8,352,624,352z M160,464c-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48 S186.5,464,160,464z M480,464c-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S506.5,464,480,464z M560,256H416V144h44.1 l99.9,99.9V256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSolid);
export default __webpack_public_path__ + "static/media/truck-solid.91c9a9157e102ccd821df79fb6cf971d.svg";
export { ForwardRef as ReactComponent };